export default __webpack_public_path__ + "static/media/logo_header.72634445.png";